// extracted by mini-css-extract-plugin
export default {"wrapper":"EditEventLogo_wrapper__prx1O"};